import { render, staticRenderFns } from "./SelectedGoods.vue?vue&type=template&id=3bee3264&scoped=true"
import script from "./SelectedGoods.vue?vue&type=script&lang=js"
export * from "./SelectedGoods.vue?vue&type=script&lang=js"
import style0 from "./SelectedGoods.vue?vue&type=style&index=0&id=3bee3264&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bee3264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bee3264')) {
      api.createRecord('3bee3264', component.options)
    } else {
      api.reload('3bee3264', component.options)
    }
    module.hot.accept("./SelectedGoods.vue?vue&type=template&id=3bee3264&scoped=true", function () {
      api.rerender('3bee3264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/list/modules/SelectedGoods/SelectedGoods.vue"
export default component.exports